module.exports = __webpack_public_path__ + "img/Läkarintyg.3e117a04.png";